(function () {
  'use strict';

  function toEmbedUrl(rawUrl, options) {
    options = options || {};
    var autoplay = options.autoplay === true || options.autoplay === 'true';
    var loop = options.loop === true || options.loop === 'true';
    var muted = options.muted === true || options.muted === 'true';

    var ytMatch = rawUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
    if (ytMatch) {
      var ytParams = ['rel=0', 'modestbranding=1', 'playsinline=1'];
      if (autoplay) ytParams.push('autoplay=1');
      if (loop) ytParams.push('loop=1', 'playlist=' + ytMatch[1]);
      if (muted) ytParams.push('mute=1');
      return 'https://www.youtube.com/embed/' + ytMatch[1] + '?' + ytParams.join('&');
    }

    var vimeoMatch = rawUrl.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) {
      var vimeoParams = ['dnt=1'];
      if (autoplay) vimeoParams.push('autoplay=1');
      if (loop) vimeoParams.push('loop=1');
      if (muted) vimeoParams.push('muted=1');
      return 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?' + vimeoParams.join('&');
    }

    return rawUrl;
  }

  function playBaftVideo(video) {
    if (!video) return;

    video.playsInline = true;
    video.muted = true;
    video.setAttribute('muted', '');

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        if (!video.hasAttribute('controls')) {
          video.controls = true;
          video.setAttribute('controls', '');
        }
      });
    }
  }

  function initVideos(root) {
    var scope = root || document;
    scope.querySelectorAll('.baft__media-video').forEach(function (video) {
      if (video.dataset.baftVideoReady) return;
      video.dataset.baftVideoReady = '1';

      if (!video.getAttribute('preload')) {
        video.setAttribute('preload', 'auto');
      }

      playBaftVideo(video);

      video.addEventListener('loadeddata', function () {
        playBaftVideo(video);
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) playBaftVideo(video);
            });
          },
          { threshold: 0.15 }
        );
        observer.observe(video);
      }
    });
  }

  function buildIframes(root) {
    root.querySelectorAll('.baft__media-iframe-wrap[data-video-url]').forEach(function (wrap) {
      var rawUrl = wrap.getAttribute('data-video-url');
      if (!rawUrl) return;

      var iframe = document.createElement('iframe');
      iframe.src = toEmbedUrl(rawUrl, {
        autoplay: wrap.getAttribute('data-video-autoplay'),
        loop: wrap.getAttribute('data-video-loop'),
        muted: wrap.getAttribute('data-video-muted'),
      });
      iframe.className = 'baft__media-iframe';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('loading', 'lazy');

      wrap.appendChild(iframe);
      wrap.removeAttribute('data-video-url');
    });
  }

  function initWidget(widget) {
    var handle   = widget.querySelector('[data-baft-handle]');
    var afterImg = widget.querySelector('[data-baft-after]');
    if (!handle || !afterImg) return;

    var pos = 50; // percent
    var dragging = false;

    function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }

    function setPos(pct) {
      pos = clamp(pct, 0, 100);
      handle.style.left      = pos + '%';
      afterImg.style.clipPath = 'inset(0 0 0 ' + pos + '%)';
    }

    function pctFromEvent(e) {
      var rect = widget.getBoundingClientRect();
      var x    = e.touches ? e.touches[0].clientX : e.clientX;
      return ((x - rect.left) / rect.width) * 100;
    }

    widget.addEventListener('mousedown', function (e) {
      e.preventDefault();
      dragging = true;
      setPos(pctFromEvent(e));
    });

    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      setPos(pctFromEvent(e));
    });

    window.addEventListener('mouseup', function () { dragging = false; });

    widget.addEventListener('touchstart', function (e) {
      dragging = true;
      setPos(pctFromEvent(e));
    }, { passive: true });

    window.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      setPos(pctFromEvent(e));
    }, { passive: true });

    window.addEventListener('touchend', function () { dragging = false; });

    // Keyboard accessibility
    widget.setAttribute('tabindex', '0');
    widget.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); setPos(pos - 2); }
      if (e.key === 'ArrowRight') { e.preventDefault(); setPos(pos + 2); }
    });

    // Apply initial position from data attr or 50
    var initPos = parseFloat(widget.dataset.baftInit || 50);
    setPos(initPos);
  }

  function initAll() {
    document.querySelectorAll('[data-baft-widget]').forEach(function (w) {
      if (!w.dataset.baftReady) {
        w.dataset.baftReady = '1';
        initWidget(w);
      }
    });

    buildIframes(document);
    initVideos(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', initAll);
})();
